/**
 * Static Hypercube.js default shader sources.
 * @example
 * const sourcefragment = Shader.sourcefragment;
 * const sourcevertex = Shader.sourcevertex;
 */
class Shader {

    /**
     * Stores the attributes needed by the shader program.
     * @type {Object<string, string>}
     * @public
     * @readonly
     * @static
     */
    static attributes = {};

    /**
     * Stores the fragment shader source.
     * @type {string}
     * @public
     * @readonly
     * @static
     */
    static sourcefragment = (

        'void main(void) {}'
    );

    /**
     * Stores the vertex shader source.
     * @type {string}
     * @public
     * @readonly
     * @static
     */
    static sourcevertex = (

        'void main(void) {}'
    );

    /**
     * Stores the uniforms needed by the shader program.
     * @type {Object<string, string>}
     * @public
     * @readonly
     * @static
     */
    static uniforms = {};
}

export {

    Shader
};

export default Shader;
